module.exports = __webpack_public_path__ + "img/logoEmblem.4983ef2.svg";